
import { IconButton, Typography } from "@mui/material"
import { tyreColNm, tyreStsNm, trnsTypNm, tyreTransactionColNm } from "./constant"
import { ArticleRounded } from "resource/muiImport"
import { numberFormat, dateFormat } from "utils"

const stsColors = {
  1: "info.main",
  2: "success.main",
  3: "warning.main",
  4: "error.main",
}

export const tyreColumns = [
  {
    field: 'ShowDetail',
    headerName: '',
    width: 40,
    align: 'center',
    renderCell: () => (
      <IconButton size="small">
        <ArticleRounded color="primary" />
      </IconButton>
    )
  },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "TyrCd",
    headerName: tyreColNm.TyrCd,
    width: 130,
  },
  {
    field: "TyrBrand",
    headerName: tyreColNm.TyrBrand,
    width: 120,
  },
  {
    field: "TyrModel",
    headerName: tyreColNm.TyrModel,
    width: 120,
  },
  {
    field: "TyrSzNm",
    headerName: tyreColNm.TyrSzId,
    width: 130,
  },
  {
    field: "TyrStsId",
    headerName: tyreColNm.TyrStsId,
    width: 90,
    align: 'center',
    renderCell: ({ value }) => (
      <Typography variant="body2" sx={{ color: stsColors[value] || 'text.primary', fontWeight: 'bold' }}>
        {tyreStsNm[value] || value}
      </Typography>
    )
  },
  {
    field: "TukCd",
    headerName: tyreColNm.TukId,
    width: 100,
  },
  {
    field: "TlrLicNm",
    headerName: tyreColNm.TlrId,
    width: 100,
  },
  {
    field: "TyrPos",
    headerName: tyreColNm.TyrPos,
    width: 80,
    align: 'center',
  },
  {
    field: "Mileage",
    headerName: tyreColNm.Mileage,
    width: 110,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "PurchPr",
    headerName: tyreColNm.PurchPr,
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "SupSNm",
    headerName: tyreColNm.SupId,
    width: 120,
  },
  {
    field: "Dscp",
    headerName: tyreColNm.Dscp,
    flex: 1,
    minWidth: 120,
  },
]

export const tyreTransactionColumns = [
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "TrnsDte",
    headerName: tyreTransactionColNm.TrnsDte,
    width: 110,
    valueFormatter: ({ value }) => dateFormat(value),
  },
  {
    field: "TrnsTyp",
    headerName: tyreTransactionColNm.TrnsTyp,
    width: 90,
    align: 'center',
    renderCell: ({ value }) => (
      <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
        {trnsTypNm[value] || value}
      </Typography>
    )
  },
  {
    field: "TukCd",
    headerName: tyreTransactionColNm.TukId,
    width: 100,
  },
  {
    field: "TlrLicNm",
    headerName: tyreTransactionColNm.TlrId,
    width: 100,
  },
  {
    field: "TyrPos",
    headerName: tyreTransactionColNm.TyrPos,
    width: 80,
    align: 'center',
  },
  {
    field: "Mileage",
    headerName: tyreTransactionColNm.Mileage,
    width: 110,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "UntPr",
    headerName: tyreTransactionColNm.UntPr,
    width: 100,
    align: "right",
    valueFormatter: ({ value }) => value ? numberFormat(value) : "-",
  },
  {
    field: "SupSNm",
    headerName: tyreTransactionColNm.SupId,
    width: 120,
  },
  {
    field: "Dscp",
    headerName: tyreTransactionColNm.Dscp,
    flex: 1,
    minWidth: 120,
  },
]
